module.exports = __webpack_public_path__ + "img/4a92ba9.jpg";